import {
  PlayerLeaderboardDesktop,
  PlayerLeaderboardHeadTitleCell,
  PlayerLeaderboardMobile,
  playerTableHeader,
} from './player-leaderboard-responsive';
import { Mobile } from '@wwe-portal/ui/components/responsive';
import { LeaderboardRowDesktopLayout } from '@wwe-portal/ui/features/leaderboard/leaderboard-row';
import { PlayerLeaderboardProps } from './player-leaderboard.type';
import { LeaderboardSkeleton } from './leaderboard-skeleton';
import { FC } from 'react';

export const PlayerRowHeaderDesktop: FC<{
  customColumnName?: Partial<typeof playerTableHeader>;
  compact: boolean;
}> = ({ customColumnName, compact }) => {
  return (
    <LeaderboardRowDesktopLayout
      compact={compact}
      className="text-text700 text-xs font-semibold uppercase"
      points={customColumnName?.point || playerTableHeader.point}
      rank={customColumnName?.rank || playerTableHeader.rank}
      subtitle={customColumnName?.sub || playerTableHeader.sub}
      title={
        <PlayerLeaderboardHeadTitleCell
          compact={compact}
          main={customColumnName?.main || playerTableHeader.main}
        />
      }
    />
  );
};

export const PlayerLeaderboardSkeleton: FC<
  Pick<
    PlayerLeaderboardProps,
    'desktopHeader' | 'mobileHeader' | 'desktopRowHeader' | 'compact'
  > & {
    nRows?: number;
  }
> = ({
  desktopHeader,
  mobileHeader,
  nRows = 10,
  desktopRowHeader,
  compact,
}) => {
  return (
    <LeaderboardSkeleton
      desktopHeader={desktopHeader}
      mobileHeader={mobileHeader}
      nRows={nRows}
      desktopRowHeader={
        desktopRowHeader || <PlayerRowHeaderDesktop compact={compact} />
      }
    />
  );
};

export const PlayerLeaderboard = ({
  mobileHeader,
  desktopHeader,
  desktopRowHeader,
  data,
  rowHeader,
  classNames,
  rowClassNames,
  containerClassnames,
  rowClassName,
  hideAvatar = false,
  currentUserId,
  compact,
  customColumnNames,
}: PlayerLeaderboardProps) => {
  return (
    <Mobile
      fallback={
        <PlayerLeaderboardDesktop
          compact={compact}
          currentUserId={currentUserId}
          containerClassnames={containerClassnames}
          data={data}
          rowClassNames={rowClassNames}
          classNames={classNames}
          desktopHeader={desktopHeader}
          desktopRowHeader={desktopRowHeader}
          rowClassName={rowClassName}
        />
      }
      loading={
        <PlayerLeaderboardSkeleton
          compact={compact}
          desktopHeader={desktopHeader}
          mobileHeader={mobileHeader}
        />
      }
    >
      <PlayerLeaderboardMobile
        currentUserId={currentUserId}
        hideAvatar={hideAvatar}
        data={data}
        rowHeader={rowHeader}
        mobileHeader={mobileHeader}
        rowClassName={rowClassName}
        containerClassnames={containerClassnames}
        customColumnNames={customColumnNames}
      />
    </Mobile>
  );
};
